import { Component, OnInit, Input, Inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificationsService } from 'angular2-notifications';
import { trigger, transition, style, animate } from '@angular/animations';
import { InterpretationService } from '../../interpretation.service';
import { FileReaderEvent } from '../../../../shared/models/FileReader';
import { UpdateComponentPhotoModel, Condition, UpdateConditionPhotoModel, AddComponentPhotoModel, AddThermalPhotoModel, AddSMUPhotoModel } from '../../models/interpretation.model';
import { EditPhotoComponent } from '../../../../shared/components/edit-photo/edit-photo.component';
import { UserService } from '../../../../shared/services/user.service';
import { AdditionalObservationListViewModel, InspectionAdditionalObservationImagesVM, PopupEndPoint } from '../../../../modules/inspection/models/create-inspection.model';
import { TemperatureInspectionService } from '../../../Temperature/temperature-inspection.service';
import { ThermographyInspectionService } from '../../../../../app/modules/Thermography/thermography-inspection.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { SetupImplementService } from '../../../../modules/GET_NEW_UI/setup-implement/setup-implement.service';
import { Subscription } from 'rxjs/Subscription';
import { SaveQuestionImageParams } from '../../../../modules/GET_NEW_UI/setup-implement/setup-implement.model';
import { heicTo } from 'heic-to';


@Component({
  selector: 'view-photo',
  templateUrl: './view-photo.component.html',
  styleUrls: ['./view-photo.component.scss'],
  animations: [
    trigger(
      'fadeIn', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms', style({ opacity: 1 }))
        ])
      ]
    )]
})




export class ViewPhotoComponent implements OnInit {
  conditionType: Condition;
  photoId: number;
  inspectionId: number;
  photoLoading = true;
  photo: string;
  private reloadPhoto = false;
  isInspector = false;
  isInterpreter = false;
  comingFrom: PopupEndPoint;
  equipmentId: number;
  inspectionDetailDraftId: number;
  temperatureInspectionId:number
  temperatureInspectionPhoto:string;
  temperatureInspectionDetailId : number;
  temperatureInspectionDetailPhoto:string;
  thermoInspectionDetailId:number;
  thermoInspectionDetailPhoto:string;
  inspectionDraftId: number;
  additionalObservationList: AdditionalObservationListViewModel;
  imageData:InspectionAdditionalObservationImagesVM
  isedit:boolean=true;
  photoType:string;
  equipmentid:number;
  img: string;
  TphotoId:number;
  isThermal:boolean;
  isEquipmentSmuHrs:boolean;
  side:number;
  UpdateEqPhoto: boolean = false;
  obsPointId: number;
  obsPointImg: string;
  obsPointImgType: string;
  imageUrl: string;
  isImageUrl: boolean = false;
  isManuallyClosed: boolean = false;
  private _subscriptions: Subscription[] = [];
  imagePath: string;


  constructor(private _dialogRef: MatDialogRef<ViewPhotoComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _sanitizer: DomSanitizer,
    private _notify: NotificationsService,
    private _interp: InterpretationService,
    private _editPhotoDialog: MatDialog,
    private _user: UserService,
    private  _temperatureService: TemperatureInspectionService,
    private _thermographyService:ThermographyInspectionService,
    private _implementService: SetupImplementService
    ) { }

  ngOnInit() {
    this.checkPermissions();
    this.comingFrom = this._data.comingFrom;

console.log("data____LInkNO", this._data)
    if (this.comingFrom) {
      switch (this.comingFrom) {
        case PopupEndPoint.ObservationListCreateInspection:
          this.imageData=this._data.imageData;
          this.additionalObservationList = this._data.observationList;          
          this.isImageUrl = this._data.isImagePath;
          console.log(this.imageData);
          break;
        case PopupEndPoint.ObservationListInterpretation:
          this.additionalObservationList = this._data.observationList;
          this.imageData=this._data.imageData;
        break;
      }
    }
    
    this.isThermal = this._data.isThermal;
    this.isEquipmentSmuHrs = this._data.isEquipmentSmuHrs;
    this.inspectionId = this._data.inspectionId;
    this.TphotoId = this._data.TphotoId;
    this.side=this._data.side;
    this.temperatureInspectionId = this._data.temperatureInspectionId;
    this.temperatureInspectionPhoto=this._data.temperatureInspectionPhoto;
    this.isedit = this._data.isedit;
    this.temperatureInspectionDetailId=this._data.temperatureInspectionDetailId;
    this.temperatureInspectionDetailPhoto=this._data.temperatureInspectionDetailPhoto;
    this.thermoInspectionDetailId=this._data.thermoInspectionDetailId;
    this.thermoInspectionDetailPhoto=this._data.thermoInspectionDetailPhoto;
    this.photoId = this._data.photoId;
    this.conditionType = this._data.conditionType;
    this.inspectionDraftId = this._data.inspectionDraftId;
    this.inspectionDetailDraftId = this._data.inspectionDraftDetailId;
    this.equipmentId = this._data.equipmentId;
    this.photoType = this._data.photoType,
    this.equipmentid = this._data.equipment_id, 
    this.photo = this._data.img;
    this.obsPointId = this._data.ObsPointId;
    this.obsPointImg = this._data.ObsPointImg;
    this.obsPointImgType = this._data.ObsPointType;
    this.imageUrl = this._data.imageUrl;
    //console.log("this.data", this._data)
      this.getPhoto();
    this._dialogRef.beforeClosed().subscribe(() => {
      if (this.isManuallyClosed) {
        return;
      }
     this._dialogRef.close(this.reloadPhoto);
    });
    
    if(this.isedit == undefined){
      this.isedit= true;
    }
    //console.log("isedit", this.isedit)
  }

  checkPermissions() {
    this._user.getUserJobRoles().subscribe(
      jobRoles => {
        jobRoles.forEach(role => {
          switch (role.Name) {
            case 'Inspectors':
              this.isInspector = true;
              break;
            case 'Interpreters':
            case 'Super User':
            case 'Administrator':
              this.isInterpreter = true;
              this.isInspector = true;
              break;
              case 'Customer Admin':
                this.isInspector = true;
              this.isInterpreter = true;
                break;
          }
        });
      },
      error => {
        console.error(error);
        this._notify.error('Error', 'Unable to check your job roles. ');
      }
    );
  }

  // editPhoto() {
  //   const editPhotoModalRef = this._editPhotoDialog.open(EditPhotoComponent, {
  //     data: { photoWithExt: 'data:image/png;base64,' + this.photo }
  //   });
  //   editPhotoModalRef.afterClosed().subscribe(res => {
  //     if (res != null) {
  //       this.updatePhoto(res.photo);
  //     }
  //   });
  // }

  editPhoto() {
    if (!this.isImageUrl) {
      const base64Image = 'data:image/png;base64,' + this.photo;
      this.openEditModal(base64Image);
      return;
    }
    this._interp.getBase64Image(this.photo).subscribe({
      next: (res: string) => {
        const base64Image = 'data:image/png;base64,' + res;
        this.openEditModal(base64Image);
      },
      error: (err) => {
        console.error('Error converting image:', err);
        this._notify?.error?.('Error', 'Unable to load image for editing.');
      }
    });
  }


  openEditModal(base64Image: string) {
    const editPhotoModalRef = this._editPhotoDialog.open(EditPhotoComponent, {
      data: { photoWithExt: base64Image }
    });
    editPhotoModalRef.afterClosed().subscribe(res => {
      if (res != null) {
        this.photo = res.photo;
        this.updatePhoto(res.photo);
      }
    });
  }

  assignPhotoData(data: string) {
    this.photo = data;
    this.photoLoading = false;
  }

  errorMessage(error: any) {
    console.error(error);
    this._notify.error('Error', 'Unable to load the photo. Please contact TrackTreads support. ');
  }

  ///This class needs to be refactored
  getPhoto() {
    console.log("popup data ", this._data);
    if (this.comingFrom) {
      switch (this.comingFrom) {
        case PopupEndPoint.ObservationListCreateInspection:
          if(this.isImageUrl){
            this.assignPhotoData(this.imageData.Image);
          }
          else {
            this._interp.GetObservationListDraftPhoto(this.additionalObservationList.Id,this.imageData.Id).subscribe(p => {
            this.assignPhotoData(p);
          }, err => this.errorMessage(err));
          }
        break;
        case PopupEndPoint.ObservationListInterpretation:
        this._interp.GetInspectionObservationListPhoto(this.additionalObservationList.Id,this.imageData.Id).subscribe(p => {
          this.assignPhotoData(p);
        }, err => this.errorMessage(err));
        break;
      }
    }
    else
      if(this.isThermal){
        this._interp.getThermalPhoto(this.inspectionId, this.side, this.TphotoId).subscribe(p => {
          this.assignPhotoData(p);
        }, err => {
          this.updatePhotoError('Failed', 'Unable to view the photo. Please contact TrackTreads support. ');
        });
      }
      else if(this.isEquipmentSmuHrs){
        if(this.inspectionId !== undefined && this.inspectionId >0){
          this._interp.getSmuHrsPhoto(this.inspectionId ).subscribe(p => {
            this.assignPhotoData(p);
          }, err => {
            this.updatePhotoError('Failed', 'Unable to view the photo. Please contact TrackTreads support. ');
          });
        }
        else{
          this.assignPhotoData(this.imageUrl);
        }
      }
    // Is a condition photo. Like track sag for example.
      else if (this.conditionType != null && this.inspectionId !== undefined) {
        this._interp.getConditionPhoto(this.inspectionId, this.conditionType).subscribe(p => {
          this.assignPhotoData(p);
        }, err => {
          this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
        });
      } else if (this.inspectionDraftId !== undefined && this.inspectionDetailDraftId === undefined) {
      console.log(`Create inspection  ${this.conditionType} on draft id ${this.inspectionDraftId} ` );
      if(this.imageUrl != null && this.imageUrl != undefined && this.imageUrl !=''){
        this.isImageUrl = true;
        this.assignPhotoData(this.imageUrl);
      }
      else {
        this._interp.getInspectionDraftConditionPhoto(this.inspectionDraftId, this.conditionType, this.equipmentId).subscribe(p => {
        this.assignPhotoData(p);
      }, err => {
        this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
      });
      }
    } else if (this.inspectionDetailDraftId !== undefined && this.photoId !== undefined) {
      console.log(`Create inspection detail  ${this.inspectionDetailDraftId} ` );
      this._interp.getInspectionDetailPhoto(this.inspectionDetailDraftId, this.equipmentId, this.photoId).subscribe(p => {
        this.assignPhotoData(p);
      }, err => {
        this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
      });
    } 
    else if (this.temperatureInspectionId !== undefined && this.temperatureInspectionPhoto !== null) {
      this.assignPhotoData(this.temperatureInspectionPhoto);
    } 
    else if (this.temperatureInspectionDetailId !== undefined && this.temperatureInspectionDetailPhoto !== null) {
      this.assignPhotoData(this.temperatureInspectionDetailPhoto);
    } 
    else if (this.thermoInspectionDetailId !== undefined && this.thermoInspectionDetailPhoto !== null) {
     // console.log("assignData_____", this.thermoInspectionDetailPhoto)
      this.assignPhotoData(this.thermoInspectionDetailPhoto);
    }
    else if(this.inspectionId!= undefined &&  this.photoId!== undefined){ // Is a photo attached to a component
      this._interp.getComponentPhoto(this.inspectionId, this.photoId).subscribe(p => {
        this.assignPhotoData(p);
      }, err => {
        this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
      });
    }
    else if(this.obsPointId!= undefined &&  this.obsPointImg!== undefined){ // Is a photo attached to a component
      this.assignPhotoData(this.obsPointImg);
    }
    else{
      if(this.inspectionId>0){
        this._interp.getInspectionEquipmentPhoto(this.inspectionId).subscribe(p => {
          if(p.m_Item1){
            this.assignPhotoData(p.m_Item2);
          }else{
            this.assignPhotoData(this.photo);
          }
        }, err => {
          this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
        });
      }else{
        this._interp.getEquipmentPhoto(this.equipmentid).subscribe(p => {
          if(p.m_Item1){
            this.assignPhotoData(p.m_Item2);
          }else{
            this.assignPhotoData(this.photo);
          }
        }, err => {
          this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
        });
      }
    }
  }

  deletePhotoSuccess(title: string, message: string) {
    this._notify.success(title, message);
    this.reloadPhoto = true;
    this.isManuallyClosed = true; 
    console.log("isImageUrl", this.isImageUrl);
    this._dialogRef.close({removed: true});
  }

  updatePhotoError(title: string, message: string) {
    this._notify.error(title, message);
    console.error(message);
    this.photoLoading = false;
  }

  deletePhoto() {
    if (this.comingFrom) {
      switch (this.comingFrom) {
        case PopupEndPoint.ObservationListCreateInspection:
          if(this.isImageUrl){
            console.log('this.inspectionId', this.inspectionId);
             this.photo = '';
             this.imageUrl = '';
             this.imageData.Image = '';
             this.imageData.ImagePath = '';
             this.deletePhotoSuccess('Deleted', 'Observation List Image has been successfully removed');
          }else {
            this._interp.DeleteObservationListDraftPhoto(this.additionalObservationList.Id,this.imageData.Id).subscribe(r => {
            this.deletePhotoSuccess('Deleted', 'Observation List Image has been successfully removed');
          }, err => this.errorMessage(err));
          }
        break;
        case PopupEndPoint.ObservationListInterpretation:
          this._interp.DeleteInspectionObservationListPhoto(this.additionalObservationList.Id,this.imageData.Id).subscribe(r => {
            this.deletePhotoSuccess('Deleted', 'Observation List Image has been successfully removed');
          }, err => this.errorMessage(err));
        break;
      }
    }else if(this.isThermal){
      this._interp.deleteThermalPhoto(this.inspectionId, this.side, this.TphotoId).subscribe(p => {
        if (p.m_Item1) {
          this.deletePhotoSuccess('Deleted',  p.m_Item2);
        } else {
          this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');        }
      }, err => {
        this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
      });
    }
    else if(this.isEquipmentSmuHrs){
      this._interp.deleteSmuHourPhoto(this.inspectionId).subscribe(p => {
        if (p.m_Item1) {
          this.deletePhotoSuccess('Deleted',   p.m_Item2);
        } else {
          this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');        }
      }, err => {
        this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
      });
    }
    // Is a condition photo. Like track sag for example.
    else if (this.conditionType !== undefined && this.inspectionId !== undefined) {
      this._interp.deleteConditionPhoto(this.inspectionId, this.conditionType).subscribe(p => {
        if (p.m_Item1) {
          this.deletePhotoSuccess('Deleted',  p.m_Item2);
        } else {
          this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');        }
      }, err => {
        this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
      });
    } else if (this.inspectionDraftId !== undefined && this.inspectionDetailDraftId === undefined) {
      console.log(`Delete  ${this.conditionType} on draft id ${this.inspectionDraftId} ` );
            if(this.imageUrl != null && this.imageUrl != undefined && this.imageUrl !=''){
        this.isImageUrl = true;
        this.photo = '';
        this.imageUrl = '';
        this.deletePhotoSuccess('Deleted', 'Image has been successfully removed');
      }
      else {
      this._interp.deleteDraftConditionPhoto(this.inspectionDraftId, this.conditionType, this.equipmentId).subscribe(p => {
        this.deletePhotoSuccess('Deleted', 'Image has been successfully removed');
      }, err => {
        this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
      });
      }
      
    } else if (this.inspectionDetailDraftId !== undefined && this.photoId !== undefined) {
      console.log(`Delete  ${this.inspectionDetailDraftId} ` );
        this._interp.deleteInspectionDetailPhoto(this.inspectionDetailDraftId, this.equipmentId, this.photoId).subscribe(p => {
        this.deletePhotoSuccess('Deleted', 'Image has been successfully removed');
      }, err => {
        this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
      });
    }else if (this.temperatureInspectionId !== undefined) {
     
      this._temperatureService.deleteTemperatureInspectionPhoto(this.temperatureInspectionId).subscribe(p => {
        this.deletePhotoSuccess('Deleted', 'Image has been successfully removed');
      }, err => {
        this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
      });
    }
    else if (this.temperatureInspectionDetailId !== undefined) {
     
      this._temperatureService.deleteTemperatureInspectionDetailPhoto(this.temperatureInspectionDetailId).subscribe(p => {
        this.deletePhotoSuccess('Deleted', 'Image has been successfully removed');
      }, err => {
        this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
      });
    }

    else if (this.thermoInspectionDetailId !== undefined) {
     
      this._thermographyService.deleteThermographyInspectionDetailPhoto(this.thermoInspectionDetailId).subscribe(p => {
        this.deletePhotoSuccess('Deleted', 'Image has been successfully removed');
      }, err => {
        this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
      });
    }
    else if(this.inspectionId !==undefined &&  this.photoId!== undefined){ // Is a photo attached to a component
      this._interp.deleteComponentPhoto(this.inspectionId, this.photoId).subscribe(p => {
        if (p.m_Item1) {
          this.deletePhotoSuccess('Deleted', p.m_Item2);
        } else {
          this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
        }
      }, err => {
        this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
      });
    }
    else{
      //console.log("delete", this.equipmentid)
      this._interp.deleteEquipmentPhoto(this.equipmentid).subscribe(p => {
        if (p.m_Item1) {
          this.deletePhotoSuccess('Deleted', p.m_Item2);
        } else {
          this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
        }
      }, err => {
        this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
      });
    }
  }

  updatePhotoSuccess(title: string, message: string) {
    this._notify.success(title, message);
    this.reloadPhoto = true;
    if(this.isImageUrl){
      this.isManuallyClosed = true; 
      this._dialogRef.close({
        removed: false,
        imageUrl: this.imageUrl,
        imagePath: this.imagePath
    });
    console.log("isImageUrl", this.imageUrl);
    }
    else
      this.getPhoto();
  }


  updatePhoto(newPhoto: string) {
    this.photoLoading = true;
    //console.log("Updateee", this.equipmentid, this.comingFrom)
    // Is a condition photo. Like track sag for example.
    if (this.comingFrom) {
      switch (this.comingFrom) {
        case PopupEndPoint.ObservationListCreateInspection:
          console.log("DATAT__GGGG", this.imageData,this.imageData.Id);
          const photo = new AddComponentPhotoModel();
          photo.NewPhoto = newPhoto;
          photo.InspectionId = this.inspectionId === 0 ? this.inspectionDraftId : this.inspectionId;
          this._interp.addInspectionComponentPhoto(photo).subscribe(res => {
            this.imageData.Image = res.ImageUrl;
            this.imageData.ImagePath = res.ImagePath;
            if (this.inspectionId !== 0) {
              const index = this.additionalObservationList.ObsImages.findIndex(
                img => img.Id === this.imageData.Id
              );
              if (index !== -1) {
                this.additionalObservationList.ObsImages[index].Image = res.ImageUrl;
                this.additionalObservationList.ObsImages[index].ImagePath = res.ImagePath;
              }
            }
            this.updatePhotoSuccess('Success', 'Updated Observation List Photo');
          }, err => this.errorMessage(err));
        //   if (this.inspectionId === 0 ) {
        //     const photo = new AddComponentPhotoModel();
        //     photo.NewPhoto = newPhoto;
        //     photo.InspectionId = this.inspectionDraftId;
        //     this._interp.addInspectionComponentPhoto(photo).subscribe(res => {
        //       this.imageData.Image = res.ImageUrl;
        //       this.imageData.ImagePath = res.ImagePath;
        //       this.imageUrl = res.ImageUrl;
        //       this.imagePath = res.ImagePath;
        //       this.updatePhotoSuccess('Success', 'Updated Observation List Photo');
        //     }, err => this.errorMessage(err));
        //   } else {
        //        this._interp.UpdateObservationListDraftPhoto(this.additionalObservationList.Id, newPhoto,this.imageData.Id).subscribe(r => {
        //        this.updatePhotoSuccess('Success', 'Updated Observation List Photo');
        //    }, err => this.errorMessage(err));
        //  }
        break;
        case PopupEndPoint.ObservationListInterpretation:
        this._interp.UpdateInspectionObservationListPhoto(this.additionalObservationList.Id, newPhoto,this.imageData.Id).subscribe(r => {
          this.updatePhotoSuccess('Success', 'Updated Observation List Photo');
        }, err => this.errorMessage(err));
        break;
      }
    }
    else
    if(this.isThermal){
      const photo = new AddThermalPhotoModel();
      photo.NewPhoto = newPhoto;
      photo.PhotoId = this.TphotoId;
      photo.InspectionId = this.inspectionId;
      photo.Side=this.side;
      this._interp.updateThermalPhoto(photo).subscribe(p => {
        if (p.m_Item1) {
          this.updatePhotoSuccess('Updated',  p.m_Item2);
        } else {
          this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
        }
      });
    }

     //Equipmentsmu upload start
 else if(this.isEquipmentSmuHrs){
  const photo = new AddSMUPhotoModel();
  photo.InspectionId = this.inspectionId;
  photo.NewPhoto = newPhoto;
  if(this.inspectionId !== undefined && this.inspectionId > 0){
    this._interp.updateInspectionSMUPhoto(photo.InspectionId,photo.NewPhoto).subscribe(r => {
      if (r.m_Item1 > 0) {
        this.updatePhotoSuccess('Updated',  r.m_Item2);
        this.photoLoading = false;
      } else {
        this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
        console.error(r.m_Item2);
        this.photoLoading = false;
      }
    });
  }
  else{
    this.photoLoading = false;
    this.assignPhotoData(newPhoto);
    //console.log("this.assignPhotoData(newPhoto);", newPhoto);
    this.isManuallyClosed = true; 
    this._dialogRef.close({
      removed: false,
      imageUrl: newPhoto,
      imagePath: ""
  });
  }
}
  //Equipmentsmu upload End
   else if (this.conditionType !== undefined && this.inspectionId !== undefined) {
      const photo = new UpdateConditionPhotoModel();
      photo.Condition = this.conditionType;
      photo.InspectionId = this.inspectionId;
      photo.NewPhoto = newPhoto;
      this._interp.updateConditionPhoto(photo).subscribe(p => {
        if (p.m_Item1) {
          this.updatePhotoSuccess('Updated',  p.m_Item2);
        } else {
          this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
        }
      }, err => {
        this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
      });
    } else if (this.inspectionDraftId !== undefined  && this.inspectionDetailDraftId === undefined) {
        console.log(`Create inspection  ${this.conditionType} on draft id ${this.inspectionDraftId} ` );

      if(this.imageUrl != null && this.imageUrl != undefined && this.imageUrl !=''){
        const newPhotoModel = new AddComponentPhotoModel();
       // newPhotoModel.InspectionDetailId = this.inspectionDetailId;
        newPhotoModel.InspectionId = this.inspectionDraftId;
        newPhotoModel.NewPhoto = newPhoto;
    this._interp.addInspectionComponentPhoto(newPhotoModel).subscribe(r => {
      console.log("rrrrrr", r);
      if (r.ImagePath != null && r.ImagePath != undefined) {
         this.imageUrl = r.ImageUrl;
        this.imagePath = r.ImagePath;
        this.isImageUrl = true;
        this.photoLoading = false;
        this.updatePhotoSuccess('Uploaded', "Photo updated successfully");
      } else {
        this.updatePhotoError('Failed', 'Unable to upload the photo. Please contact TrackTreads support. ');
        //console.error(r.m_Item2);
        this.photoLoading = false;
      }
    });
      }
      else{
      const photo = new UpdateConditionPhotoModel();
      photo.Condition = this.conditionType;
      photo.NewPhoto = newPhoto;
      photo.InspectionId = this.inspectionDraftId;
      photo.EquipmentId = this.equipmentId;
      //
      this._interp.updateInspectionDraftConditionPhoto(photo).subscribe(p => {
        if (p.m_Item1) {
          this.updatePhotoSuccess('Updated',  p.m_Item2);
        } else {
          this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
        }
      }, err => {
        this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
      });
      }

    } else if (this.inspectionDetailDraftId !== undefined && this.photoId !== undefined) {
      console.log(`Create inspection detail  ${this.inspectionDetailDraftId} ` );
      const photo = new UpdateComponentPhotoModel();
      photo.NewPhoto = newPhoto;
      photo.PhotoId = this.photoId;
      photo.InspectionId = this.inspectionDraftId;
      this._interp.updateComponentPhotoOnInspectionDraft(photo).subscribe(p => {
        if (p.m_Item1) {
          this.updatePhotoSuccess('Updated',  p.m_Item2);
        } else {
          this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
        }
      });
    }else if (this.temperatureInspectionId !== undefined) {
      
      const photo = new AddComponentPhotoModel();
      photo.NewPhoto = newPhoto;
      photo.InspectionId = this.temperatureInspectionId;
      this._temperatureService.addTemperatureInspectionPhoto(photo).subscribe(p => {
        if (p.m_Item1) {
          this.updatePhotoSuccess('Updated',  p.m_Item2);
        } else {
          this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
        }
      });
    } 
    else if (this.temperatureInspectionDetailId !== undefined && this.thermoInspectionDetailId == undefined) {
      //console.log("temperatureInspectionDetailId", this.temperatureInspectionDetailId)
      const photo = new AddComponentPhotoModel();
      photo.NewPhoto = newPhoto;
      photo.InspectionDetailId= this.temperatureInspectionDetailId;
      //console.log("Phot_tempperature", photo)
      this.temperatureInspectionDetailPhoto=newPhoto;
      this._temperatureService.addTemperatureInspectionDetailPhoto(photo).subscribe(p => {
        if (p.m_Item1) {
          this.updatePhotoSuccess('Updated',  p.m_Item2);
        } else {
          this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
        }
      });
    } 

    else if (this.thermoInspectionDetailId !== undefined && this.temperatureInspectionDetailId==undefined) {
     /// console.log("thermoInspectionDetailId", this.thermoInspectionDetailId)
      const photo = new AddComponentPhotoModel();
      photo.NewPhoto = newPhoto;
      photo.InspectionDetailId= this.thermoInspectionDetailId;
      this.thermoInspectionDetailPhoto =  newPhoto;
      //console.log("Phot_________________________Thermogarphy", photo)
      this._thermographyService.addThermogarphyInspectionDetailPhoto(photo).subscribe(p => {
        if (p.m_Item1) {
          this.updatePhotoSuccess('Updated',  p.m_Item2);
        } else {
          this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
        }
      });
    } 

    else if(this.equipmentid!==undefined){
      //console.log("editt", this.equipmentid)
      const photo = new UpdateComponentPhotoModel();
      photo.InspectionId = this.equipmentid;
      photo.NewPhoto = newPhoto;
      photo.InspectionDetailId = this.inspectionId;
      photo.UpdateEqPhoto = this.UpdateEqPhoto;
      this._interp.updateEquipmentPhoto(photo).subscribe(p => {
        if (p.m_Item1) {
          this.updatePhotoSuccess('Updated',  p.m_Item2);
        } else {
          this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
        }
      }, err => {
        this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
      });
    }
    else if(this.obsPointId!= undefined &&  this.obsPointImg!== undefined){
      var saveParams: SaveQuestionImageParams = new SaveQuestionImageParams();
      this.obsPointImg = newPhoto;
      saveParams.ObservationPointId = this.obsPointId;
      saveParams.ImageData = this.obsPointImg;
      this._subscriptions.push(this._implementService.SaveQuestionImage(saveParams).subscribe( () => {
        this.updatePhotoSuccess('Updated', 'Updated Observation Point Photo');
      },
      (error) => {
        // Handle error if the save request fails
        console.error('Error updating photo:', error);
        this.updatePhotoSuccess('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
      }
    ));
      
    }
    else { // Is a photo attached to a component
      const photo = new UpdateComponentPhotoModel();
      photo.InspectionId = this.inspectionId;
      photo.PhotoId = this.photoId;
      photo.NewPhoto = newPhoto;
      this._interp.updateComponentPhoto(photo).subscribe(p => {
        if (p.m_Item1) {
          this.updatePhotoSuccess('Updated',  p.m_Item2);
        } else {
          this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
        }
      }, err => {
        this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
      });
    }
  }

   compressImage(src) {
    return new Promise((res, rej) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        const elem = document.createElement('canvas');
        let width, height;
        width = img.width;
        height = img.height;
        console.log('width', width)
        console.log('height', height)
        var ratio = height / width; //cal aspect ratio
        let imageWidth = 800;//643
        var new_height = imageWidth * ratio; //calculate new height
        elem.width = imageWidth;
        elem.height = new_height;
        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, imageWidth, new_height);
        const data = ctx.canvas.toDataURL();
        res(data);
      }
      img.onerror = error => rej(error);
    })
  }

  async replacePhotoClicked(event: any) {
  if (!(event.target.files && event.target.files[0])) {
    return;
  }
  this.photoLoading = true;
  const file = event.target.files[0];
  const extension = file.name.split('.').pop()?.toLowerCase();
  const mimeType = (file.type || '').toLowerCase();
  const isHeic =
    extension === 'heic' ||
    extension === 'heif' ||
    mimeType.includes('heic') ||
    mimeType.includes('heif');

  const processFile = (f: File) => {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const imageUrl = e.target.result;
      this.compressImage(imageUrl)
        .then((res: string) => {
          if (res) {
            this.updatePhoto(res.split(',')[1]);
          }
        })
        .catch(() => {
          this.photoLoading = false;
        });
    };
    reader.readAsDataURL(f);
  };
  try {
    if (isHeic) {
      const convertedBlob = await heicTo({
        blob: file,
        type: "image/jpeg",   // Use "toType" if your installed version requires it
        quality: 0.8
      });
      const convertedFile = new File(
        [convertedBlob as Blob],
        "converted.jpg",
        {
          type: "image/jpeg"
        }
      );
      processFile(convertedFile);
    } else {
      processFile(file);
    }
  } catch (err: any) {
    this.photoLoading = false;
    console.error("HEIC conversion failed", err);
    this.updatePhotoError(
      "Failed",
      "Unable to process this HEIC image. Please convert it to JPG and try again."
    );
  }
  event.target.value = null;
}
  
  // replacePhotoClicked(event: any) {
  //   if (event.target.files && event.target.files[0]) {
  //     this.photoLoading = true;
  //     //this._cdr.detectChanges();
  //     let file = event.target.files[0];
  //     const isHeic = file.type === "image/heic" || file.name.toLowerCase().endsWith(".heic");
  //     const processFile = (f: File) => {
  //       const reader = new FileReader();
  //       reader.onload = (e: any) => {
  //         const imageUrl = e.target.result;
  //         this.compressImage(imageUrl)
  //           .then((res: string) => {
  //             if (res) {
  //               this.updatePhoto(res.split(',')[1]);
  //             }
  //           })
  //       };
  //       reader.readAsDataURL(f);
  //     };
  //     if (isHeic) {
  //       (heic2any as any).default({
  //         blob: file,
  //         toType: "image/jpeg",
  //         quality: 0.8
  //       })
  //       .then((result: any) => {
  //         const convertedBlob = Array.isArray(result) ? result[0] : result;
  //         const convertedFile = new File([convertedBlob], "converted.jpg", {
  //           type: "image/jpeg"
  //         });
  //         processFile(convertedFile);
  //       })
  //       .catch((err: any) => {
  //         this.photoLoading = false;
  //         console.error("HEIC conversion failed", err);
  //         this.updatePhotoError('Failed', 'Unable to delete the photo. Please contact TrackTreads support. ');
  //         //alert("Unable to process HEIC image");
  //       });
  //     } else {
  //       processFile(file);
  //     }
  //     event.target.value = null;
  //   }
  // }

  // replacePhotoClicked(event: any) {
  //   if (event.target.files && event.target.files[0]) {
  //     // this.updatePhoto(event.target.files[0]);
  //     const reader = new FileReader();
  //     reader.readAsDataURL(event.target.files[0]);
  //     reader.onload = (event: any) => {
  //       const imageUrl = (event.target["result"]);
  //       //resize photo
  //       this.compressImage(imageUrl).then((res: string) => {
  //         // console.log("imageUrl", res)
  //         if (res) {
  //          //console.log('res', res)
  //           //photo.NewPhoto =  this.uploadPhoto(res.split(',')[1]);
  //           this.updatePhoto(res.split(',')[1]);
  //         }
  //       })
  //       //this.updatePhoto(event.target.result.split(',')[1]);
  //     };
  //   }
  // }

  sanitize(image: string) {
    if(this.isImageUrl)
      return image;
    else 
      return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' +image);
  }

  openLargeImage(base64Data: string): void {
    const imageBase64 = this.isImageUrl
      ? base64Data
      : `data:image/jpeg;base64,${base64Data}`;

    const width = window.screen.availWidth;
    const height = window.screen.availHeight;

    const newWindow = window.open(
      "",
      "_blank",
      `toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width=${width},height=${height},top=0,left=0`,
    );

    if (!newWindow) {
      alert("Popup blocked. Please allow popups for this website.");
      return;
    }

    newWindow.document.write(`
<!DOCTYPE html>
<html>
<head>
<title>Image Viewer</title>

<style>

html,body{
    margin:0;
    width:100%;
    height:100%;
    overflow:hidden;
    background:#000;
    font-family:Arial,Helvetica,sans-serif;
}

.toolbar{
    position:fixed;
    top:12px;
    left:50%;
    transform:translateX(-50%);
    display:flex;
    align-items:center;
    justify-content:space-between;
    min-width:430px;
    padding:6px 8px;
    background:rgba(35,35,35,.92);
    border-radius:8px;
    box-shadow:0 4px 15px rgba(0,0,0,.45);
    z-index:9999;
}

.toolbar-left{
    display:flex;
    align-items:center;
    gap:6px;
}
.toolbar button{
    height:30px;
    min-width:30px;
    border:none;
    border-radius:4px;
    background:#1976d2;
    color:#fff;
    font-size:14px;
    font-weight:600;
    cursor:pointer;
    padding:0 8px;
    transition:.2s;
}

.toolbar button:hover{
    background:#1565c0;
}

.zoomText{
    color:#fff;
    min-width:46px;
    text-align:center;
    font-size:14px;
    font-weight:600;
}

.fit-btn{
    min-width:82px;
}

.close-btn{
    margin-left:12px;
    width:30px !important;
    min-width:30px !important;
    height:30px;
    padding:0 !important;
    background:#d32f2f !important;
    font-size:18px !important;
    font-weight:bold;
    line-height:30px;
}

.close-btn:hover{
    background:#b71c1c !important;
}

.viewer{
    width:100%;
    height:100%;
    display:flex;
    justify-content:center;
    align-items:center;
    overflow:hidden;
    cursor:grab;
}

.viewer:active{
    cursor:grabbing;
}

img{
    user-select:none;
    -webkit-user-drag:none;
    transform-origin:center center;
    transition:transform .08s linear;
    max-width:none;
    max-height:none;
}

</style>

</head>

<body>

<div class="toolbar">
    <div class="toolbar-left">
        <button id="zoomOut" title="Zoom Out">−</button>

        <span id="zoomValue" class="zoomText">125%</span>

        <button id="zoomIn" title="Zoom In">+</button>

        <button id="reset" title="Reset Zoom">125%</button>

        <button id="fit" class="fit-btn">Screen Fit</button>
    </div>

    <button class="close-btn" title="Close" onclick="window.close()">
        &#10005;
    </button>
</div>

<div class="viewer" id="viewer">
    <img id="img" src="${imageBase64}" draggable="false"/>
</div>

<script>

const img=document.getElementById('img');
const viewer=document.getElementById('viewer');
const zoomText=document.getElementById('zoomValue');

let scale=1.25;
let posX=0;
let posY=0;
let isDragging=false;
let startX=0;
let startY=0;

function updateImage(){

    img.style.transform =
        'translate(' + posX + 'px,' + posY + 'px) scale(' + scale + ')';

    zoomText.innerText = Math.round(scale * 100) + '%';

    viewer.style.cursor = canDrag() ? 'grab' : 'default';
}

updateImage();

document.getElementById('zoomIn').onclick=function(){
    scale = Math.min(scale + 0.1, 5);
    updateImage();
};

document.getElementById('zoomOut').onclick=function(){
    if(scale>0.2){
        scale = Math.max(scale - 0.1, 0.2);
        updateImage();
    }
};

document.getElementById('reset').onclick=function(){
    scale = 1.25;
    posX=0;
    posY=0;
    updateImage();
};

document.getElementById('fit').onclick=function(){

    const vw=viewer.clientWidth;
    const vh=viewer.clientHeight;

    const iw=img.naturalWidth;
    const ih=img.naturalHeight;

    scale = Math.min(vw / iw, vh / ih) * 0.95;

    posX=0;
    posY=0;

    updateImage();
};

function canDrag() {
    return true;
}

viewer.addEventListener('wheel',function(e){

    e.preventDefault();

    if(e.deltaY<0)
        scale+=0.1;
    else if(scale>0.2)
        scale-=0.1;

    updateImage();

},{passive:false});

viewer.addEventListener('mousedown', function (e) {

    if (!canDrag()) return;

    isDragging = true;

    startX = e.clientX - posX;
    startY = e.clientY - posY;

    viewer.style.cursor = 'grabbing';

    e.preventDefault();

});

window.addEventListener('mousemove',function(e){

    if(!isDragging) return;

    posX=e.clientX-startX;
    posY=e.clientY-startY;

    updateImage();

});

window.addEventListener('mouseup', function () {

    isDragging = false;

    viewer.style.cursor = canDrag() ? 'grab' : 'default';

});

</script>

</body>

</html>
`);

    newWindow.document.close();
    newWindow.focus();

    newWindow.moveTo(0, 0);
    newWindow.resizeTo(width, height);
  }
}
